export default __webpack_public_path__ + "static/media/Room2.381ab9b1.png";